import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(null)).finally(() => setChecking(false));
  }, []);
  const logout = async () => { await api.post("/auth/logout"); setUser(null); };
  return <AuthContext.Provider value={{ user, setUser, checking, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);